import { connect } from 'react-redux';

import DeactivatedBanner from './DeactivatedBanner';
import styles from './index.module.less';

import { Logo as HVLogo } from '$HVUI';
import Button from '$Molecules/Buttons/Button';
import { multilingualGreeting } from '$Utils';

const prodPrefix = 'https://healthvana-production.s3.amazonaws.com';

export const Welcome = props => {
    let { organization, company, isKiosk } = props.introduction;
    let companyWelcome = function () {
        const leadString = isKiosk ? 'Welcome to' : 'Online registration for';
        if (organization && organization.name) {
            return (
                <span>
                    {leadString} {organization.name}
                </span>
            );
        }
        return (
            <span>
                {leadString} {company.title}
            </span>
        );
    };

    // Logos can be uploaded in CW and become part of the Company Model.
    // In the event of no logo being found, we skip showing a logo altogether.

    // company.logo is a path string set over in DynamicRegistration/Pages/Introduction/duck.js
    // see the loadCookies() function for more details.

    // In our local environments, we need to append
    // the s3 prefix to see prod assets (i.e. customer uploaded logos)

    // In the django prod environment, USE_S3 is set to True
    // which auto appends the S3 bucket URL to stuff in the
    // `media` folders, so we don't need the prefix
    const uploadedLogo =
        !!company.logo &&
        `${company.logo.startsWith('https') ? '' : prodPrefix}${company.logo}`;

    if (organization?.is_inactive) {
        return <DeactivatedBanner companyTitle={company.title} />;
    }

    return (
        <div id="dynamic-welcome">
            <div className={styles['logo-container']}>
                {uploadedLogo && (
                    <div id="company-logo" className={styles['company-logo']}>
                        <img src={uploadedLogo} alt={`${company.name} logo`} />
                    </div>
                )}
                <div className={styles['hv-logo']}>
                    <HVLogo />
                </div>
            </div>
            <h1 className={styles['big-greeting']}>{multilingualGreeting()}</h1>
            <h2 className={styles['company-welcome']}>{companyWelcome()}</h2>
            <div className={styles['get-started']}>
                <Button element="Link4" to="/has-account" text="Get Started" />
            </div>
        </div>
    );
};

export const mapStateToProps = (state, ownProps) => {
    return Object.assign(
        {},
        {
            introduction: state.introduction
        },
        ownProps
    );
};

export default connect(mapStateToProps, null)(Welcome);
